import $ from 'jquery';
import formSend from '@utils/form-send';

export const elements =
{
    call: '.js-InputValidate-Call'
};

export const onBlur = function()
{
    const $input = $(this);
    const $form = $input.parents('form');

    formSend
    (
        {
            form: $form,
            validation:
            {
                type: 'single-input',
                input: $input
            },
        }
    );
};

export default
{
    init(params)
    {
        params.$document.on('blur', elements.call, onBlur);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/form/single-input.js